<template>
  <div class="schedule-calendar-container" style="margin:20px 0">
    <!-- 연,월 -->
    <div class="flex flex-center justify-center" style="margin-bottom:8px">
      <div class="flex">
        <i class="material-icons icon-arrow unselect" @click="clickPrev">keyboard_arrow_left</i>
        <div>{{ `${currentDate.year()}년 ${currentDate.month()+1}월` }}</div>
        <i class="material-icons icon-arrow unselect" @click="clickNext">keyboard_arrow_right</i>
      </div>
    </div>

    <!-- 요일 -->
    <div class="flex wrap">
    <div class="lp-day"
      v-for="(day,idx) in days" :key="'day-'+idx">{{ day }}</div>
    </div>
    <!-- 일 -->
    <div class="flex wrap lp-dates">
      <div class="lp-date unselect"
           :class="{'disable-schedule-calendar': disableSchedule(date)}"
           v-for="(date,idx) in dates" :key="'date-'+idx"
           @click="clickDate(date,idx)">
        <div v-if="date.operatingTime && date.operatingTime.is_closed" class="item-day-all"  style="position:relative">
          <!-- 일자 표시 -->
          <div style="position:absolute;top:0;width: 100%" :style="dayStyle(date)">{{ date.day > 0 ? date.day : '' }}</div>
          <div style="color:red;">휴무</div>
        </div>
        <div v-else style="height:100%">
          <!-- 일자 표시 -->
          <div :style="dayStyle(date)">{{ date.day > 0 ? date.day : '' }}</div>
          <!-- 일에 해당하는 시간 스케쥴 -->
          <div v-if="date.times" class="relative">
            <div v-for="(time, timeIdx) in date.times.slice(0,2)"
                 :key="date.day+'-time-'+timeIdx">
              <!-- 브레이크 타임 -->
              <div  v-if="time.is_break"
                    class="lp-break-time">{{ `${timeToStr(time.start_time)} ~ ${timeToStr(time.end_time)}` }}</div>
              <!-- 일반 시간 스케쥴 -->
              <div v-else class="flex space-between lp-time" @click.stop.prevent="clickTime(date, timeIdx)">
                <div>{{ `${timeToStr(time.start_time)} ~ ${timeToStr(time.end_time)}` }}</div>
                <div>{{ time.stock_infinite ? '∞' : time.stock }}</div>
              </div>
            </div>
            <div class="lp-time-all" v-if="date.times.length>2" @click.stop.prevent="clickAll(date)">전체 보기({{ date.times.length }})</div>
            <!-- 스케쥴 전체 -->
            <div v-if="vTimeAll && selectedDate.day === date.day" class="box-schedule" @click.stop.prevent="">
              <div class="flex space-between flex-align" style="margin-bottom:4px">
                <div style="width:24px"></div>
                <div style="color:#989898;font-weight:600">{{ date.start_date }}</div>
                <i class="material-icons" @click="vTimeAll=false">close</i>
              </div>
              <div v-for="(time, timeIdx) in date.times"
                   :key="date.day+'-time-'+timeIdx">
                <!-- 브레이크 타임 -->
                <div  v-if="time.is_break"
                      class="lp-break-time">{{ `브레이크 타임 ${timeToStr(time.start_time)} ~ ${timeToStr(time.end_time)}` }}</div>
                <!-- 일반 시간 스케쥴 -->
                <div v-else class="flex space-between lp-time" @click="clickTime(date, timeIdx)">
                  <div>{{ `${timeToStr(time.start_time)} ~ ${timeToStr(time.end_time)}` }}</div>
                  <div>{{ time.stock_infinite ? '∞' : time.stock }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="date.all_time" class="item-day-all" style="height:calc(70% - 20px);font-size:12px">
            <div class="flex-between"
                 style="width: 100%;padding:2px 4px;background-color:rgba(255,88,49,.15);color:#656565">
              <div>종일 예약</div>
              <div>{{ date.stock_infinite ? '∞' : date.stock }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 스케쥴 신규 등록 모달 -->
    <sweet-modal ref="dayModal" @close="closeDayModal">
      <div class="columns is-multiline" v-if="selectedDate">
        <div class="column is-full">
          <div class="lp-title">선택 날짜</div>
          <div style="color:#989898">{{ selectedDate.start_date }}</div>
          <div class="lp-title flex-align" v-if="selectedPack!=='booking'">
            <div style="margin-right: 16px">시작 시간 / 소요 시간(분)
              <tool-tip style="margin-left:4px"
                        icon="help_outline"
                        text="종일 예약' 선택 시 일정 수정이 불가합니다.(삭제 후 재등록 필요)"></tool-tip>
            </div>
            <div v-if="selectedDate.org_all_time" style="font-size:14px">종일 예약</div>

          </div>
          <div class="flex flex-align" v-if="selectedPack!=='booking'">
            <time-picker
              :disabled="selectedDate.all_time"
              :start="selectedDate.day_start" :end="selectedDate.day_end"
              :usingRange="selectedDate.usingRange" :disableRange="selectedDate.disableRange"
              :value.sync="selectedDate.start_time"></time-picker>
            <div style="margin:0 20px">
              <input type="number" min="5" :disabled="selectedDate.all_time"
                     v-model="selectedDate.running_time"><span style="font-size:14px;margin-left:4px">분</span>
            </div>
          </div>

          <lp-check-bool label="종일 예약"
                         :disabled="selectedDate.repeat_daily"
                         v-if="!selectedDate.org_all_time"
                         @onCheck="clickAllTime"
                         style="margin-top:12px"
                         :checkedVal.sync="selectedDate.all_time"></lp-check-bool>

          <lp-check-bool :disabled="selectedDate.all_time"
                         v-if="!selectedDate.modify"
                         style="margin-top:12px"
                         :checkedVal.sync="selectedDate.repeat_daily" label="하루 2회 이상 자동 생성"/>

          <div v-if="selectedDate.repeat_daily" style="margin-top:20px">
            <div class="lp-title">회차별 간격(분)</div>
            <input type="number" min="5" v-model="selectedDate.interval"><span style="font-size:14px;margin-left:4px">분</span>
          </div>

          <div style="margin-top:20px" v-if="!selectedDate.modify">
            <div class="lp-title">반복</div>
            <lp-radio-button :options="repeatOptions" :value.sync="selectedDate.repeat_type"></lp-radio-button>
          </div>

          <div v-if="selectedDate.repeat_type>0" style="margin-top:20px">
            <div class="lp-title">종료일</div>
            <admin-date-picker type="date" placeholderDate="없음"
                               @setDate="res => selectedDate.end_date = res"
                               :data="selectedDate.end_date"></admin-date-picker>
          </div>

          <div class="lp-title">재고</div>
          <div class="flex flex-align">
            <div style="margin-right:20px">
              <input type="number" v-model="selectedDate.stock" min="0" v-if="!selectedDate.stock_infinite">
              <input type="number" v-else disabled="true">
            </div>
            <lp-check-bool :checkedVal.sync="selectedDate.stock_infinite" label="무한대"/>
          </div>
          <lp-radio v-if="selectedDate.modify" style="margin-top:16px"
                    :val.sync="modifyValue"
                    value_name="value"
                    label_name="label"
                    :block="true"
                    :data="modifyOptions"></lp-radio>
        </div>
        <div class="column is-full flex btn-group-justify-end" style="margin-top: 150px;" v-if="!disableSchedule(selectedDate)">
          <button v-if="selectedDate.modify || selectedDate.all_time"
                  class="button is-light" @click="$refs.delModal.open()">삭제</button>
          <button class="button is-primary" @click="clickReg">저장</button>
        </div>
      </div>
    </sweet-modal>

    <sweet-modal ref="delModal">
      <div class="columns is-multiline">
        <div class="column is-full">
          <div class="lp-title">삭제 범위</div>
          <lp-radio :val.sync="delValue"
                    value_name="value"
                    label_name="label"
                    :block="true"
                    :data="delOptions"></lp-radio>
        </div>

        <div class="column is-full flex btn-group-justify-end">
          <button class="button is-light" @click="$refs.delModal.close()">취소</button>
          <button class="button is-primary" @click="clickDelete">확인</button>
        </div>
      </div>
    </sweet-modal>
    <!--<sweet-modal ref="modifyModal">
      <div class="columns is-multiline">
        <div class="column is-full">
          <div class="lp-title">수정 범위</div>
          <lp-radio :val.sync="modifyValue"
                    value_name="value"
                    label_name="label"
                    :block="true"
                    :data="modifyOptions"></lp-radio>
        </div>

        <div class="column is-full flex btn-group-justify-end">
          <button class="button is-light" @click="$refs.modifyModal.close()">취소</button>
          <button class="button is-primary" @click="clickModify">확인</button>
        </div>
      </div>
    </sweet-modal>-->
  </div>
</template>

<script>
  import { SweetModal } from 'sweet-modal-vue'
  import moment from 'moment'
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import LpRadioButton from "../../../module/common/LpRadioButton";
  import TimePicker from "../../../module/common/TimePicker";
  import LpRadio from "../../../module/common/LpRadio";
  import ToolTip from "../../../module/common/ToolTip";

  export default {
    name: "ScheduleCalendar",
    components: {
      ToolTip,
      LpRadio,
      TimePicker,
      LpRadioButton,
      LpCheckBool,
      SweetModal
    },
    props: {
      operatingTime: {
        type: Array
      },
      selectedPack: {
        type: String
      },
    },
    data() {
      return {
        vTimeAll: false,
        days: ['일','월','화','수','목','금','토'],
        dates: [],
        newDates: [],
        currentDate: '',
        selectedDate: undefined,
        selectedDateIndex: -1,
        repeatOptions: [
          {
            label: '안함',
            value: 0,
            selected: true
          },
          {
            label: '매일',
            value: 1,
            selected: true
          },
          {
            label: '매주',
            value: 2,
            selected: true
          },
          {
            label: '2주',
            value: 3,
            selected: true
          },
          {
            label: '매월',
            value: 4,
            selected: true
          },
          {
            label: '매년',
            value: 5,
            selected: true
          }
        ],
        delValue: 0,
        delOptions: [
          {
            label: '이 회차만 삭제',
            value: 0
          },
          {
            label: '향후 반복 일정에서의 이 회차 일괄 삭제',
            value: 1
          },
          {
            label: '향후 모든 회차 일괄 삭제',
            value: 2
          }
        ],
        modifyValue: 0,
        modifyOptions: [
          {
            label: '이 회차만 재고 수정',
            value: 0
          },
          {
            label: '향후 반복 일정에서의 이 회차 일괄 재고 수정',
            value: 1
          },
          {
            label: '향후 모든 회차 일괄 재고 수정',
            value: 2
          }
        ],
        stockInfinite: true,
        repeatDates: [],
      }
    },
    created() {
      this.currentDate = moment();
      if(this.$route.query.id) {
        // 수정인 경우 기존 등록된 내용 불러오기
        this.getMonthly();
      }
      // 신규 생성시 : deprecated (수정일때만 동작되도록 절차 변경)
      else {
        this.setDates();
      }
      this.getPanelSetting();
    },
    methods: {
      closeDayModal() {
        this.selectedDate = undefined;
      },
      clickAllTime(bool) {
        if(bool) {
          this.selectedDate.start_time = ''
          this.selectedDate.running_time = 0
        }
      },
      disableSchedule (date) {
        if (date.start_date) {
          let selected_date = date.start_date.replace('-', '');
          let today = moment().format('YYYY-MM-DD').replace('-', '');
          return selected_date < today;
        }
        else return false;
      },
      getPanelSetting () {
        this.$axios.get(this.getUrl('panel/detail/setting'), {
          params: {
            path: 'product/create'
          }
        }).then(res=>{
          let repeat = res.data.data;
          if(repeat) {
            if(repeat.length>0) this.repeatOptions = repeat;
          }
        })
      },
      // 시간 스케쥴 클릭
      clickTime(date, timeIdx) {
        let time = date.times[timeIdx];

        this.selectedDate = {
          org_all_time: time.all_time,
          schedule_id: time.schedule_id,
          time_id: time.id,
          org_start_date: time.org_start_date,
          start_date: date.start_date,
          all_time: date.all_time,
          org_start_time: time.org_start_time,
          org_end_time: time.org_end_time,
          start_time: time.start_time,
          end_time: time.end_time,
          running_time: moment(`2000-01-01 ${time.end_time}`).diff(`2000-01-01 ${time.start_time}`, 'minutes'),
          stock: time.stock,
          stock_infinite: time.stock_infinite,
          usingRange: true,
          operatingTime: date.operatingTime,
          disableRange: date.disableRange,
          day_start: date.day_start,
          day_end: date.day_end,
          year: date.year,
          month: date.month,
          day: date.day,
          modify: true
        };
        this.modifyValue = 0;
        this.$refs.dayModal.open();
      },
      // 전체 보기 클릭
      clickAll(date) {
        this.selectedDate = date;
        this.vTimeAll = true;
      },
      timeToObject(time) {
        let result = {
          hour: 0,
          min: 0
        };
        if(time && time.indexOf(':')>-1) {
          let times = time.split(':');
          result.hour = parseInt(times[0]);
          result.min = parseInt(times[1]);
        }
        return result;
      },
      // 삭제 버튼 클릭
      clickDelete() {
        if(this.$route.query.id) {
          let params = this.cloneItem(this.selectedDate);
          if(!params.org_start_date)
            params.org_start_date = params.start_date;
          params.repeat = this.delValue;
          this.$axios.delete(this.getUrl(`product/${this.$route.query.id}/schedule/${params.schedule_id}`), {
            params: params
          }).then(res => {
            this.getMonthly();
            this.$refs.delModal.close();
            this.$refs.dayModal.close();
          });
        } else {
          for(let i=0; i<this.newDates.length; i++) {
            let date = this.newDates[i];
            if(date.start_date === this.selectedDate.org_start_date) {
              removeIndex(this.newDates,i);
              break;
            }
          }
          this.setDates();
          this.setTimeSchedule();
          this.$refs.delModal.close();
          this.$refs.dayModal.close();
        }
      },
      // 수정
      clickModify() {
        let params = this.cloneItem(this.selectedDate);
        params.repeat = this.modifyValue;
        params.end_time = this.addTime(params.start_time, params.running_time);
        this.$axios.patch(this.getUrl(`product/${this.$route.query.id}/schedule/${params.schedule_id}`), params).then(() => {
          this.getMonthly();
          //this.$refs.modifyModal.close();
          this.$refs.dayModal.close();
        });
      },
      // 저장
      clickReg() {
        if(!this.selectedDate.all_time && this.selectedDate.start_time === '') {
          this.toast('시작 시간을 선택해주세요.');
          return;
        }
        if(!this.selectedDate.all_time && !this.selectedDate.running_time) {
          this.toast('분을 입력하세요.');
          return;
        }

        // 회차 수정
        if(this.selectedDate.modify) {
          //this.$refs.modifyModal.open();
          this.clickModify();
          return;
        }

        let dates = this.cloneItem(this.selectedDate);
        if(dates.all_time) {
          delete dates.start_time;
          delete dates.running_time;
          delete dates.interval;
        }
        this.$store.commit('setLoading', true);
        this.$axios.post(this.getUrl(`product/${this.$route.query.id}/schedule`), dates).then(()=>{
          this.getMonthly();
          this.$store.commit('setLoading', false);
          this.$refs.dayModal.close();
        });
      },
      clickDate(date,idx) {
        // console.log(date)
        /*if(
          (date.operatingTime.is_closed || date.day === 0 || (date.times && date.times.length > 0))
        ) return;*/
        if(
          (date.day === 0 || date.operatingTime.is_closed || this.disableSchedule(date))
        ) return;

        let selectedDate = this.cloneItem(date);
        selectedDate.org_all_time = selectedDate.all_time;

        // 하루 종일
        if(selectedDate.all_time) {
          selectedDate.modify = true;
          selectedDate.day_start = this.timeToObject('00:00');
          selectedDate.day_end = this.timeToObject('23:59');
          selectedDate.start_time = '00:00';

          this.selectedDate = selectedDate;
        }
        else {
          selectedDate.stock = 1;
          selectedDate.stock_infinite = false;
          selectedDate.repeat_type = 0;
          selectedDate.repeat_daily = false;
          selectedDate.all_time = false;
          selectedDate.interval = 30;
          selectedDate.running_time = 60;
          if(!date.operatingTime.open_end) {
            date.operatingTime.open_end = '23:59'
          }
          if(!date.operatingTime.open_start) {
            date.operatingTime.open_start = '00:00'
          }
          selectedDate.day_start = this.timeToObject(date.operatingTime.open_start);
          selectedDate.day_end = this.timeToObject(date.operatingTime.open_end);

          this.selectedDate = this.cloneItem(selectedDate);
          if(!this.selectedDate.start_time)
            this.selectedDate.start_time = '';

          this.selectedDateIndex = idx;

          // 매월 - O번째 O요일로 표기
          let days = this.getWeeksDays(this.selectedDate.start_date);
          if(days.isLast)
            this.repeatOptions[4].label = `매월 마지막주 ${days.dayStr}요일`;
          else
            this.repeatOptions[4].label = `매월 ${days.week}번째 ${days.dayStr}요일`;

          if(this.selectedPack === 'booking') {
            this.selectedDate.all_time = true;
          }
        }

        this.$refs.dayModal.open();
      },
      getWeeksDays(dates) {
        let selDate = moment(dates);
        let date = selDate.date();
        let day = selDate.day();
        let end_month = selDate.endOf('month').date();
        return {
          isLast: (date + 7 > end_month),
          week: Math.ceil(date/7),
          day: day,
          dayStr: ['일','월','화','수','목','금','토'][day]
        }
      },
      async getMonthly() {
        let year = this.currentDate.year();
        let month = this.currentDate.month()+1;
        let res = await this.$axios.get(this.getUrl(`product/${this.$route.query.id}/schedule/monthly/${year}-${month}`));
        this.dates = res.data.dates;

        // 종일 패키지 사용 여부
        this.$store.commit('setDailyEnable', res.data.daily_enable);

        // 할인 기간 시간대별 할인 - 시간대 목록 저장하기
        let times = [];
        this.dates.forEach(date => {
          if(date.times) {
            date.times.forEach(time => {
              let len = times.filter(item=> { return item.start_time === time.start_time && time.end_time === item.end_time}).length;
              if(len===0) {
                times.push(time);
              }
            });
          }
        });
        this.$store.commit('setScheduleTimes', times.sort((a,b) => {
          return a.start_time > b.start_time ? 1 :
            a.end_time > b.end_time ? 0 : -1 }));
      },
      clickPrev() {
        this.currentDate.subtract(1, 'months');
        if(this.$route.query.id) {
          this.getMonthly();
        } else {
          this.setDates();
          this.setTimeSchedule();
        }
      },
      clickNext() {
        this.currentDate.add(1, 'months');
        if(this.$route.query.id) {
          this.getMonthly();
        } else {
          this.setDates();
          this.setTimeSchedule();
        }
      },
      setTimeSchedule() {
        this.newDates.forEach(schedule => {
          let schedule_start_date = schedule.start_date;
          let repeat_type = schedule.repeat_type;
          this.dates.filter(dt=>{return dt.day>0}).forEach(date => {
            let diff_days = moment(date.start_date).diff(moment(schedule_start_date), 'days');

            // 해당 날짜
            if(diff_days === 0) {
              this.setDateTimeSchedule(schedule.start_date, date, schedule.start_time, schedule.running_time, schedule.stock,
              schedule.interval, schedule.repeat_daily);
            }

            // 휴무일 아닌날
            else if(diff_days>0 && !date.operatingTime.is_closed) {

              // 매월 n번째 주 n요일 비교
              let equal_day_month = false;
              if(repeat_type === 4) {
                let next_days = this.getWeeksDays(schedule.start_date);
                let date_days = this.getWeeksDays(date.start_date);
                // (같은 마지막주 || 같은 주) && 같은 요일
                if
                (((next_days.isLast && date_days.isLast) ||
                  (next_days.week === date_days.week)
                ) && next_days.day === date_days.day)
                {
                  equal_day_month = true;
                }
              }

              if(
                (repeat_type === 1) ||    // 매일
                (repeat_type === 2 && diff_days % 7 === 0) ||   // 매주
                (repeat_type === 3 && diff_days % 14 === 0) ||   // 2주
                (repeat_type === 4 && equal_day_month) ||   // 매월
                (repeat_type === 5 && schedule.month === date.month && schedule.day === date.day) // 매년
              ) {
                this.setDateTimeSchedule(schedule.start_date, date, schedule.start_time, schedule.running_time, schedule.stock,
                  schedule.interval, schedule.repeat_daily);
              }
            }
          });
        });


        /*this.dates.forEach(date => {
          if(date.start_time && date.start_time !== '') {
            // 해당일에 타임 스케쥴 생성
            this.setDateTimeSchedule(date, date.start_time, date.running_time, date.stock, date.interval, date.repeat_daily);
            // 다음날부터 반복 처리
            if(date.repeat_type>0) {
              for(let i=idx;i<this.dates.length;i++) {
                let next_date = this.dates[i];
                // 휴일 제외
                if(next_date.operatingTime.is_closed) {
                  continue;
                }

                let diff = moment(next_date.start_date).diff(moment(date.start_date), 'days');

                // 매월 n번째 주 n요일 비교
                let equal_day_month = false;
                if(date.repeat_type === 4) {
                  let next_days = this.getWeeksDays(next_date.start_date);
                  let date_days = this.getWeeksDays(date);
                  // (같은 마지막주 || 같은 주) && 같은 요일
                  if
                  (((next_days.isLast && date_days.isLast) ||
                    (next_days.week === date_days.week)
                  ) && next_days.day === date_days.day)
                  {
                    equal_day_month = true;
                  }
                }

                if(
                  (date.repeat_type === 1)      // 매일
                  || (date.repeat_type === 2 && (diff % 7 === 0))    // 매주
                  || (date.repeat_type === 3 && (diff % 14 === 0))   // 2주간격
                  || (date.repeat_type === 4 && equal_day_month)   // 매월
                  || (date.repeat_type === 5 && (next_days.month === date.month && next_days.day === date.day))   // 매년*!/
                )
                {
                  this.setDateTimeSchedule(next_date, date.start_time, date.running_time, date.stock, date.interval, date.repeat_daily);
                }
              }
            }
          }

          idx++;
        });*/


      },
      setDateTimeSchedule(org_start_date, date, start_time, running_time, stock, interval, repeat_daily) {
        //날짜 내에 설정된 내용으로 타임스케쥴 생성
        if(!date.times) {
          date.times = [];
        }
        //시작시간
        let end_time = this.pushTime(org_start_date, date.times, start_time, running_time, stock);

        // 일정 반복
        if(repeat_daily) {
          // 영업 종료 시간
          let op_end = this.timeToInt(date.operatingTime.open_end);
          let break_start = date.operatingTime.break_start;
          let break_end = date.operatingTime.break_end;

          while(this.timeToInt(end_time) < op_end) {
            end_time = this.addTime(end_time, interval);   // 앞서 들어간 스케쥴 중, 종료시간에 interval 더해서 계산

            /*
             브레이크 타임이 설정되어있는 경우, end_time이 브레이크 타임 시작 시간 보다 이후일 경우,
             브레이크 타임 종료시간으로 end_time 갱신하고, times에 브레이크 타임 추가
             */

            if(break_start && !find(date.times, 'is_break', true) &&
              (
              this.timeToInt(end_time) >= this.timeToInt(break_start) &&
              this.timeToInt(end_time) <= this.timeToInt(break_end)
            )) {
              date.times.push({
                org_start_date: org_start_date,
                start_time: break_start,
                end_time: break_end,
                is_break: true
              });
              end_time = break_end;
            }

            end_time = this.pushTime(org_start_date, date.times, end_time, date.running_time, date.stock);
          }
        }

        // 정렬
        date.times = date.times.sort((a,b)=> {
          let a_start = this.timeToInt(a.start_time);
          let b_start = this.timeToInt(b.start_time);
          return a_start < b_start ? -1 : a_start > b_start ? 1 : 0;
        });
      },
      pushTime(org_start_date, times, start, running, stock) {
        let end_time = this.addTime(start, running);
        times.push({
          org_start_date: org_start_date,
          org_start_time: start,
          org_end_time: end_time,
          start_time: start,
          end_time: end_time,
          stock: stock,
          is_break: false
        });
        return end_time;
      },
      addTime(time, addValue) {
        let old = moment('2000-01-01 '+time);
        let add_date = old.add(addValue, 'minutes');
        if(add_date.date() === 2) {
          return '%02d:%02d'.format(add_date.hour()+24, add_date.minute());
        } else {
          return add_date.format('HH:mm')
        }
      },
      timeToInt(time) {
        time = time.split(':');
        return parseInt(`${time[0]}${time[1]}`);
      },
      timeToStr(time) {
        if(time) {
          time = time.split(':');
          return `${time[0]}:${time[1]}`;
        } else {
          return time;
        }
      },

      setDates() {
        this.dates = [];
        let day = 0;
        let year = this.currentDate.year();
        let month = this.currentDate.month()+1;
        let start_day = this.currentDate.startOf('month').day();
        let end_date = this.currentDate.endOf('month').date();

        let len = 42;
        if(start_day + end_date <= 35) {
          len = 35;
        }

        for(let i=0; i< len; i++) {
          if(i>=start_day && day<end_date) {
            let date = {
              year: year,
              month: month,
              day: ++day,
              start_date: '%4d-%02d-%02d'.format(year, month, day),
              end_date: undefined,
              start_time: '',
              running_time: 60,
              interval: 30,
              repeat_daily: false,
              repeat_type: 0,
              stock: 1,
              stock_infinite: false
            };
            let day_moment = moment(date.start_date).day() - 1;
            let time = null;
            // 일요일
            if(day_moment === -1) {
              time = this.operatingTime[6];
            } else {
              time = this.operatingTime[day_moment];
            }

            date.operatingTime = time;
            time.open_start = this.timeToStr(time.open_start);
            time.open_end = this.timeToStr(time.open_end);
            time.break_start = this.timeToStr(time.break_start);
            time.break_end = this.timeToStr(time.break_end);

            date.day_start = this.timeToObject(time.open_start);
            date.day_end = this.timeToObject(time.open_end);
            // 브레이크 타임 설정되어있는 경우
            if(time.break_start) {
              date.usingRange = true;
              date.disableRange = {
                start: this.timeToObject(time.break_start),
                end: this.timeToObject(time.break_end)
              };
            } else {
              date.usingRange = false;
            }
            this.dates.push(date);
          } else {
            this.dates.push({day: 0})
          }
        }
      },
      dayStyle(day) {
        return {
          padding: '4px',
          textAlign: 'center'
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .lp-day
    width 14.2857%
    text-align center
    padding-bottom 4px

  .lp-dates
    border-right 1px solid #ddd
    border-bottom 1px solid #ddd

  .lp-date
    width 14.2857%
    height 128px
    border-top 1px solid #ddd
    border-left 1px solid #ddd

  .lp-date:hover
    background #f5f5f5

  .icon-arrow
    padding 0px 8px

  .lp-title
    color #707070
    font-size 15px
    margin 24px 0 8px 0

  .lp-title:first-child
    margin-top 0

  input[type="number"]
    height 36px
    width 56px

  .lp-time
  .lp-break-time
    font-size 11px
    padding 2px 4px
    margin-bottom 4px
    color #656565

  .lp-time
    background rgba(255,88,49,0.15)

  .lp-break-time
    text-align center
    background #eeeeee

  .lp-time-all
    color #707070
    font-size 12px
    padding 0 4px
    margin-top 8px
    font-weight 600

  .box-schedule
    position absolute
    left 93px
    top 0
    z-index 100
    background white
    padding 8px 16px
    width 200px
    box-shadow 0 2px 6px 0 rgba(0,0,0,0.3)

  .item-day-all
    display flex
    justify-content center
    align-items center
    height 100%
  .item-day-all div
    text-align center

  .disable-schedule-calendar
    background-color #eee !important
    color #d4d4d4
    cursor unset
</style>

<style lang="stylus">
  .schedule-calendar-container .sweet-modal.is-alert
    width 600px
  .schedule-calendar-container .sweet-modal.is-alert .sweet-content
    padding-top 28px
    padding-bottom 16px
</style>
